import { LBtn, LFlex, LModal, LTitle } from "@components";
import MicrophoneTroubleShootWindows from "@assets/MicrophoneTroubleShootWindows.png";
import { useNavigate } from "react-router-dom";
import { NavItems } from "@helpers/navigation";

export const MicTroubleshootModal = ({ onTryAgain, onGetHelp, onClose }: MicTroubleshootModalProps): JSX.Element => {
    const navigate = useNavigate();

    const handleOnClose = (): void => {
        onClose?.();
    };

    const handleOnGetHelp = (): void => {
        navigate(NavItems.Assessments.ContactFacilitator.path);
    };

    const handleOnTryAgain = (): void => {
        onTryAgain?.();
    };

    return (
        <LModal
            onClose={handleOnClose}
            footer={
                <LFlex alignCenter justifyCenter className="mb-5" row>
                    <LBtn onClick={handleOnGetHelp} isBold variation="outline">
                        Contact Support
                    </LBtn>
                    <LBtn onClick={handleOnTryAgain} isBold>
                        Try Again
                    </LBtn>
                </LFlex>
            }
            fullHeight={false}
            closeOnOverlay
        >
            <LFlex alignCenter justifyCenter className="p-4">
                <LTitle color="has-text-dark-blue" size="4">
                    Troubleshoot Your Microphone
                </LTitle>
                <LFlex row>
                    <div className="content">
                        <p className="has-text-weight-bold has-text-dark-blue">On Windows, select</p>
                        <ol className="has-text-weight-bold has-text-dark-blue">
                            <li>Start</li>
                            <li>Settings</li>
                            <li>Privacy</li>
                            <li>Microphone</li>
                        </ol>
                        <p style={{ maxWidth: 400 }}>
                            In{" "}
                            <span className="has-text-weight-bold has-text-dark-blue">
                                Allow access to the microphoneon this device,
                            </span>{" "}
                            select <span className="has-text-weight-bold has-text-dark-blue">Change</span> and make sure{" "}
                            <span className="has-text-weight-bold has-text-dark-blue">
                                Microphone access for this device
                            </span>{" "}
                            is turned <span className="has-text-weight-bold has-text-dark-blue">on.</span>
                        </p>
                    </div>
                    <img src={MicrophoneTroubleShootWindows} />
                </LFlex>
            </LFlex>
        </LModal>
    );
};

interface MicTroubleshootModalProps {
    onClose?: () => void;
    onTryAgain?: () => void;
    onGetHelp?: () => void;
}
